'use client';

import { useEffect } from 'react';
import { initDatadogLogs } from '@/lib/datadog';

export default function DatadogInit() {
  useEffect(() => {
    initDatadogLogs();
  }, []);

  return null;
}
